import { useEffect, useState } from "react";
import { endpoints } from "@/lib/api";

export default function MapPage() {
  const [zones, setZones] = useState([]);
  const [active, setActive] = useState(null);
  useEffect(() => { endpoints.floorPlan().then(setZones).catch(() => {}); }, []);

  return (
    <div className="space-y-4">
      <h1 className="font-display text-4xl uppercase text-white">Event Map</h1>
      <p className="text-[#8a8d91] font-body text-sm">Tap a zone to see what's there. Perth Convention Centre, main hall.</p>

      <div className="relative w-full border border-white/10 bg-[#121212] overflow-hidden" style={{ aspectRatio: "1 / 1" }} data-testid="floor-plan">
        <div className="absolute inset-0 grain opacity-50" />
        {zones.map((z) => (
          <button key={z.id} onClick={() => setActive(z)} data-testid={`zone-${z.id}`}
            className="absolute border transition-all hover:z-10 flex items-center justify-center p-1 text-center"
            style={{
              left: `${z.x}%`, top: `${z.y}%`, width: `${z.w}%`, height: `${z.h}%`,
              background: `${z.color}22`, borderColor: active?.id === z.id ? z.color : `${z.color}88`,
              boxShadow: active?.id === z.id ? `0 0 24px ${z.color}66` : "none",
            }}>
            <span className="font-heading uppercase text-[9px] sm:text-xs leading-tight" style={{ color: z.color === "#121212" ? "#fff" : z.color }}>{z.name}</span>
          </button>
        ))}
      </div>

      {active && (
        <div className="border-l-2 bg-[#121212] px-4 py-3" style={{ borderColor: active.color }} data-testid="zone-detail">
          <div className="font-heading uppercase text-white">{active.name}</div>
          <div className="text-[#8a8d91] font-body text-sm">{active.desc}</div>
        </div>
      )}

      <div className="grid grid-cols-2 gap-2">
        {zones.map((z) => (
          <button key={z.id} onClick={() => setActive(z)} className="flex items-center gap-2 border border-white/10 bg-[#121212] px-3 py-2 text-left">
            <span className="w-3 h-3 shrink-0" style={{ background: z.color }} />
            <span className="font-heading uppercase text-xs text-white/85">{z.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
